import BaseApi from '@/core/HttpResources/BaseApi';
import NameValue from '@/models/nameValue.model';
import Consulta from '@/models/consulta.model';

export default class CiudadanoService {


    async syncCiudadano(cedula: any = null, noActNacimiento: any = null) {
        let ciudadanoAndConfig = await this.getCiudadanoAndCurrentConfig(cedula, noActNacimiento);
        return ciudadanoAndConfig;
    }

    // Consulta rápida temporalmente desactivada por decisión funcional.
    // async syncCiudadanoWithoutAuth(cedula: any = null, noActNacimiento: any = null) {
    //     let ciudadanoAndConfig = await this.getCiudadanoAndCurrentConfigWithoutAuth(cedula, noActNacimiento);
    //     return ciudadanoAndConfig;
    // }

    async getCiudadanoAndCurrentConfig(cedula = null, noActNacimiento = null): Promise<any> {
        let url = "Ciudadano/SyncCiudadano?cedula=" + cedula + "&actNac=" + noActNacimiento;
        let baseApi = new BaseApi(url);
        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('get', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }

    // Consulta rápida temporalmente desactivada por decisión funcional.
    // async getCiudadanoAndCurrentConfigWithoutAuth(cedula = null, noActNacimiento = null): Promise<any> {
    //     let url = "Ciudadano/SyncCiudadano?cedula=" + cedula + "&actNac=" + noActNacimiento;
    //     let baseApi = new BaseApi(url);
    //     return new Promise<Array<NameValue>>((resolve, reject) => baseApi.requestWithAccessToken('get', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    // }

    async needRefresh(identifier = null): Promise<boolean> {

        let url = "Ciudadano/needRefresh/" + identifier;
        let baseApi = new BaseApi(url);
        return new Promise<boolean>((resolve, reject) => baseApi.request('get', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }

    // Consulta rápida temporalmente desactivada por decisión funcional.
    // async needRefreshWithoutAuth(identifier = null): Promise<boolean> {
    //
    //     let url = "Ciudadano/needRefresh/" + identifier;
    //     let baseApi = new BaseApi(url);
    //     return new Promise<boolean>((resolve, reject) => baseApi.requestWithAccessToken('get', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    // }

    async resolveMergeConflict(ciudadanoAtributoInfoInstitucionId: number, ciudadanoAtributoId: number): Promise<any> {

        let url = "Ciudadano/ResolveMergePropertyConflict";
        let baseApi = new BaseApi(url);

        var data = {
            ciudadanoAtributoInfoInstitucionId,
            ciudadanoAtributoId
        };

        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('PUT', String(), data, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async getCiudadanoInfoByAttributeIds(identifier: number, ids: Array<number>): Promise<any> {

        let url = "Ciudadano/" + identifier + "/attributesByIds";
        let baseApi = new BaseApi(url);

        var data = {
            ids: ids.join(",")
        };

        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('GET', String(), null, data, (response) => resolve(response.data), reject, () => { }))
    }

    // Consulta rápida temporalmente desactivada por decisión funcional.
    // async getCiudadanoInfoByAttributeIdsWithoutAuth(identifier: number, ids: Array<number>): Promise<any> {
    //     let url = "Ciudadano/" + identifier + "/attributesByIds";
    //     let baseApi = new BaseApi(url);
    //     var data = {
    //         ids: ids.join(",")
    //     };
    //     return new Promise<Array<NameValue>>((resolve, reject) => baseApi.requestWithAccessToken('GET', String(), null, data, (response) => resolve(response.data), reject, () => { }))
    // }


    async getConsultaAbierta(userId: number): Promise<any> {

        let url = `Consulta/${userId}/abierta`;
        let baseApi = new BaseApi(url);

        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('GET', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }
    async closeConsulta(consulta: Consulta): Promise<any> {

        let url = `Consulta/${consulta.id}/close`;
        let baseApi = new BaseApi(url);

        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('PUT', String(), consulta, {}, (response) => resolve(response.data), reject, () => { }))
    }
}
